import {FormPost, GET, POST} from "../util";

const operationUrl = "api/prospective-receivable-operation/";
const inspectionUrl = "api/prospective-receivable-inspection/";

const url = {
    operation: {
        uploadPdf: `${operationUrl}upload-with-pdf`,
        save: `${operationUrl}save`,
        submitReview: `${operationUrl}:receivableId/submit-for-review`,
        submitReviewSelected: `${operationUrl}submit-selected`,
        saveAndSubmit: `${operationUrl}save-and-submit-for-review`,
        convert: `${operationUrl}:receivableId/convert`,
        convertSelected: `${operationUrl}convert-selected`,
        withdraw: `${operationUrl}:receivableId/withdraw`,
        withdrawSelected: `${operationUrl}withdraw-selected`,
        uploadExcel: `${operationUrl}upload-with-excel/:checkDocumentFileName/:isDisclosed`,
    },
    inspection: {
        listProspective: `${inspectionUrl}list-prospective`,
        listProspectiveHistory: `${inspectionUrl}list-history`,
        counts: `${inspectionUrl}counts`,
    }
};

const prospectiveReceivableApi = {
    inspection: {
        listProspective: (params = {}) => {
            return POST(url.inspection.listProspective, params);
        },
        listProspectiveHistory: (params = {}) => {
            return POST(url.inspection.listProspectiveHistory, params);
        },
        counts: () => {
            return GET(url.inspection.counts);
        },
    },
    operation: {
        uploadPdf: (params = {}) => {
            return FormPost(url.operation.uploadPdf, params);
        },
        saveItem: (params = {}) => {
            return POST(url.operation.save, params);
        },
        submitReview: (params = {}) => {
            let realUrl = url.operation.submitReview.replace(":receivableId", params);
            return POST(realUrl, {}, "application/json", 'Array');
        },
        submitReviewSelected: (ids) => {
            return POST(url.operation.submitReviewSelected, ids, "application/json", 'Array');
        },
        saveAndSubmit: (params = {}) => {
            return POST(url.operation.saveAndSubmit, params);
        },
        convert: (params = {}) => {
            let realUrl = url.operation.convert.replace(":receivableId", params);
            return POST(realUrl, params);
        },
        convertSelected: (ids) => {
            return POST(url.operation.convertSelected, ids, "application/json", 'Array');
        },
        withdraw: (params = {}) => {
            let realUrl = url.operation.withdraw.replace(":receivableId", params);
            return POST(realUrl, params);
        },
        withdrawSelected: (ids) => {
            return POST(url.operation.withdrawSelected, ids, "application/json", 'Array');
        },
        uploadExcel: (params = {}) => {
            let realUrl = url.operation.uploadExcel.replace(":checkDocumentFileName", params.checkDocumentFileName)
                .replace(":isDisclosed", params.isDisclosed);
            return FormPost(realUrl, params);
        },
    }
};
export {
    prospectiveReceivableApi
};